export default "__VITE_ASSET__CIHRKFQd__"